import cx from 'classnames'
import Styles from './AIAssistant.module.scss'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { Card, Content } from 'components/DocRightRail/screens/AIAssistant/Card'
import { HistoryButton } from 'components/DocRightRail/screens/AIAssistant/HistoryButton'
import { Skeleton } from 'components/Skeleton/Skeleton'
import { EventWizardButton, NonChannelWizard } from 'components/DocRightRail/screens/AIAssistant/EventWizardButton'
import { ActivityEventSwitch } from 'components/ActivityEvent/ActivityEvent'
import { TimelineEventType } from 'screens/Activity/Types'
import { ActivityEvent } from 'components/ActivityEvent/Types'
import { useState } from 'react'
import { useLastEvent } from 'hooks/useLastEvent'
import { ArticleFlat } from 'types'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  event: ActivityEvent
}

const Loading = () => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <Card>
      <Content>
        <div className={cx(Styles.contentWrapper, Styles.previousCard)}>
          {isSystemRedesignEnabled ? (
            <Text variant="secondary">What last happened</Text>
          ) : (
            <div className={Styles.cardTitle}>What last happened</div>
          )}
          <div className={Styles.loadingContent}>
            <Skeleton className={cx(Styles.skeleton, Styles.lg)} paragraph={false} active />
            <Skeleton className={cx(Styles.skeleton, Styles.md)} paragraph={false} active />
            <Skeleton className={cx(Styles.skeleton, Styles.sm)} paragraph={false} active />
          </div>
        </div>
      </Content>
    </Card>
  )
}

const PreviousActionCard = ({ event }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const [isTruncated, setIsTruncated] = useState(true)

  return (
    <Card>
      <Content>
        <div className={cx(Styles.contentWrapper, Styles.previousCard)}>
          {isSystemRedesignEnabled ? (
            <Text variant="secondary">What last happened</Text>
          ) : (
            <div className={Styles.cardTitle}>What last happened</div>
          )}
          <div className={Styles.content}>
            <div className={Styles.typeContent}>
              <ActivityEventSwitch
                onClick={() => setIsTruncated((expanded) => !expanded)}
                isTruncated={isTruncated}
                event={event}
                actionsEnabled={false}
                isLast={false}
                isStatic
                className={Styles.activityEvent}
                openWizard={false}
              />
            </div>
          </div>
        </div>
      </Content>
      <div className={Styles.cardFooter}>
        <HistoryButton event={event} />
        {event.type === TimelineEventType.ArticleAIGeneratedEvent &&
          [...Object.values(ChannelType), ...Object.values(NonChannelWizard)].includes(
            event.data.generation_type as ChannelType,
          ) &&
          !isSystemRedesignEnabled && <EventWizardButton event={event} />}
      </div>
    </Card>
  )
}

interface DynamicProps extends Partial<Props> {
  loading: boolean
}

const DynamicPreviousActionCard = ({ event, loading }: DynamicProps) => (
  <>
    {loading && !event && <Loading />}
    {event && <PreviousActionCard event={event} />}
  </>
)

interface ContainerProps {
  article: ArticleFlat
  layerId: string
}

export const PreviousActionCardContainer = ({ article, layerId }: ContainerProps) => {
  const { lastEvent, loading } = useLastEvent({ articleId: article.id, layerId })

  return <DynamicPreviousActionCard loading={loading} event={lastEvent} />
}

export { DynamicPreviousActionCard as PreviousActionCard }
